"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FetchProxy_1 = require("../Utility/FetchProxy");
const Config_1 = require("../Config/Config");
class Quotation {
    async detailGenerate(quotationId, use = 'final') {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/detail/generate?quotationId=${quotationId}&use=${use}`).auth().fetch();
            return await res.blob();
        }
        catch (err) {
            throw new Error(`Quotation detail generate download fail: status ${err.message}`);
        }
    }
    async detailGeneratePdf(repairOrderId, data) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/detail/generate_pdf?repairOrderId=${repairOrderId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: `{"data":"${data}"}`
            }).auth().fetch();
            return await res.blob();
        }
        catch (err) {
            throw new Error(`Quotation detail pdf fail: status ${err.message}`);
        }
    }
    async detailDownload(quotationId, use = 'final') {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/detail/download?quotationId=${quotationId}&use=${use}`).auth().fetch();
            return await res.blob();
        }
        catch (err) {
            throw new Error(`Quotation detail download fail: status ${err.message}`);
        }
    }
    async create(repairOrderId, quotation) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/complex/submit?repairOrderId=${repairOrderId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(quotation)
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Quotation create fail: status ${err.message}`);
        }
    }
    async append(repairOrderId, quotation, isLarge) {
        const quot = isLarge ? "complex" : "simple";
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/${quot}/append?repairOrderId=${repairOrderId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(quotation)
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Quotation append fail: status ${err.message}`);
        }
    }
    async list(data) {
        try {
            const listData = Object.assign({}, data);
            const list = new URLSearchParams(listData).toString();
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/list?${list}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get Quotation list: status ${err.message}`);
        }
    }
    async listTemp(masterUserId) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/quotation/listByMasterUserId?masterUserId=${masterUserId}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get Quotation ListTemp: status ${err.message}`);
        }
    }
}
exports.default = Quotation;
//# sourceMappingURL=Quotation.js.map